import type { UserPreferences } from "~/types"

export const useUserPreferences = () => {
    const config = useRuntimeConfig()

    return useCookie<UserPreferences>('customer-preferences', {
        default: () => ({
            view: 'grid',
            perPage: config.perPage
        }),
        maxAge: 60 * 60 * 24 * 1
    })
}